<template>
  <div>
    <v-layout>
      <h3 class="db--text">
        <v-icon color="db" class="mr-4">mdi-pencil</v-icon>
        {{ olympiadTitle }} Result
      </h3>
    </v-layout>
    <v-layout column v-if="!entriesLoaded" justify-center align-center class="mt-10">
      <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
      <p class="subheading-1 mt-5 primary--text font-weight-bold">Loading Result...</p>
    </v-layout>
    <v-simple-table v-else class="mt-6">
      <thead>
        <tr>
          <th class="text-left">Rank</th>
          <th class="text-left">Full name</th>
          <th class="text-left">School</th>
          <th class="text-left">Submission</th>
          <th class="text-left">Score</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, i) in entries"
          :key="item.userId"
          :class="i === 0 || i === 1 || i === 2 ? 'top' : ''"
        >
          <td>{{ i + 1}}</td>
          <td>{{ item.userName }}</td>
          <td>{{ item.userSchool }}</td>
          <td>{{ item.submissionAt | dateFormatFull }}</td>
          <td class="font-weight-bold gold--text">{{ item.score }}</td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-layout v-if="completed" class="mt-8" column align-center>
      <p class="caption mb-2">Download your participation certificate</p>
      <v-layout>
        <v-btn
          :loading="loading"
          dark
          @click="downloadCertificate"
          small
          depressed
          class="dr text-capitalize caption"
        >
          <v-icon left small color="white">mdi-download</v-icon>Download
        </v-btn>
      </v-layout>
    </v-layout>
  </div>
</template>


<script>
import jspdf from "jspdf";
import firebase from "@/firebase";
import format from "date-fns/format";
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "olympiad-result",
  props: ["olympiadId"],
  data() {
    return {
      loading: false,
      entriesLoaded: false,
      olympiadTitle: "",
      completed: false,
      finished: false,
      availableTill: null,
      submittedBy: 0,
      entries: []
    };
  },
  computed: {
    ...mapGetters([
      "isOlympiadsFetched",
      "getOlympiads",
      "getCertificate",
      "getUserDetails"
    ])
  },
  methods: {
    ...mapActions(["fetchCertificate"]),
    async fetchEntries() {
      const entries = await firebase
        .firestore()
        .collection("olympiadEntries")
        .where("olympiadId", "==", this.olympiadId)
        .orderBy("score", "desc")
        .limit(3)
        .get();
      let tempArr = [];
      entries.forEach(ent => tempArr.push(ent.data()));
      tempArr = tempArr.sort((a, b) => {
        if (a.score === b.score) {
          return a.submissionAt.toDate() > b.submissionAt.toDate() ? 1 : -1;
        } else {
          return a.score < b.score ? 1 : -1;
        }
      });

      this.entries = tempArr;
      this.entriesLoaded = true;
    },
    async downloadCertificate() {
      if (!this.getCertificate) {
        this.loading = true;
        try {
          await this.fetchCertificate();
        } finally {
          this.loading = false;
        }
      }
      const date = format(this.availableTill, "Do MMM YYYY");
      var doc = new jspdf();
      doc.setFontSize(16);
      doc.addImage(this.getCertificate, "JPEG", 0, 60, 210, 140);
      doc.setTextColor("#736A57");
      doc.text(
        `This is to certify that ${this.getUserDetails.fullName} participated in ${this.olympiadTitle} online Olympiad on ${date}`,
        10,
        125,
        { align: "justify", maxWidth: 180, lineHeightFactor: 1.5 }
      );
      return doc.save("certificate.pdf");
    }
  },
  created() {
    if (!this.isOlympiadsFetched) {
      return this.$router.push("/olympiads");
    } else {
      this.olympiads = this.getOlympiads;
      const selectedOlympiad = this.olympiads.find(
        ex => ex.olympiadId === this.olympiadId
      );
      if (!selectedOlympiad) return this.$router.push("/olympiads");
      this.olympiadTitle = selectedOlympiad.olympiadTitle;
      this.submittedBy = selectedOlympiad.completedBy;
      this.availableTill = selectedOlympiad.availableTill.toDate();
      this.finished = selectedOlympiad.finished;
      this.completed = selectedOlympiad.completed;
      this.fetchEntries();
    }
  }
};
</script>


<style>
.top {
  cursor: pointer;
}
</style>